/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import glamorous from 'glamorous';
import { position } from 'polished';
import { CHINESE } from 'app/constants/languageTypes';

type Props = {
  children: any,
  textDirection: 'default' | 'upward',
};

const Wrapper = glamorous.div({
  ...position('absolute', '0'),
});

const Default = glamorous.div({
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
});

const Upward = glamorous(Default)({
  left: '50%',
  position: 'absolute',
  top: '50%',
  transform: 'translate(-50%, -50%) rotate(-90deg)',
});

function RowPrefix({
  children,
  textDirection,
}: Props) {
  if (textDirection === 'upward') {
    return (
      <Wrapper>
        <Upward>
          {children}
        </Upward>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Default>
        {children}
      </Default>
    </Wrapper>
  );
}

function mapStateToProps(state) {
  return {
    textDirection: state.settings.language !== CHINESE ? 'upward' : 'default',
  };
}

export default connect(mapStateToProps)(RowPrefix);
